import { Box, Flex, Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import Image from 'next/image';
import useTranslation from 'next-translate/useTranslation';

export default function HowItWorks() {
  const { t } = useTranslation('services');

  return (
    <Flex
      direction="column"
      maxWidth="1216px"
      margin="0 auto"
      width={{ base: '90%', lg: '100%' }}
      mb="32px"
      gap="72px"
      pt={{ base: '40px', lg: '72px' }}
      pb={{ base: '170px', lg: '72px' }}
    >
      <Flex direction="column" alignItems="center" justifyContent="center" gap="16px">
        <Heading
          as="h2"
          width="90%"
          fontSize={{ base: '36px', lg: '48px' }}
          lineHeight={{ base: '40px', lg: '48px' }}
          fontWeight="800"
          textAlign="center"
          color="blue.900"
          ml={{ base: '0', lg: '0' }}
        >
          {t('seoConsulting.howItWorks.title')}
        </Heading>
        <Text fontSize="16px" lineHeight="24px" color="gray.600" textAlign="center" w={{ base: 'auto', lg: '658px' }}>
          {t('seoConsulting.howItWorks.description')}
        </Text>
      </Flex>
      <Grid
        w={{ base: '90%', lg: '100%' }}
        templateColumns={{ base: '72px 85%', lg: '1fr 72px 1fr' }}
        templateRows={{
          base: '32px auto auto auto 70px auto',
          lg: '112px 162px 162px 162px 70px 81px',
        }}
        gap={{ base: '17px', lg: '51px' }}
        position={{ lg: 'relative' }}
      >
        <GridItem rowStart={2} colStart={{ base: 1, lg: 2 }} h="100%">
          <Box
            position="absolute"
            bgColor="white"
            p="12px"
            borderRadius="16px"
            boxShadow="0px 25px 50px -12px rgba(0, 0, 0, 0.25);"
            zIndex={3}
          >
            <Image width={48} height={48} src="/images/how-it-works/icon1.svg" alt="icon" />
          </Box>
        </GridItem>
        <GridItem rowStart={3} colStart={{ base: 1, lg: 2 }}>
          <Box
            position="absolute"
            bgColor="white"
            p="12px"
            borderRadius="16px"
            boxShadow="0px 25px 50px -12px rgba(0, 0, 0, 0.25);"
            zIndex={3}
          >
            <Image width={48} height={48} src="/images/how-it-works/icon2.svg" alt="icon" />
          </Box>
        </GridItem>
        <GridItem rowStart={4} colStart={{ base: 1, lg: 2 }}>
          <Box
            position="absolute"
            bgColor="white"
            p="12px"
            borderRadius="16px"
            boxShadow="0px 25px 50px -12px rgba(0, 0, 0, 0.25);"
            zIndex={3}
          >
            <Image width={48} height={48} src="/images/how-it-works/icon3.svg" alt="icon" />
          </Box>
        </GridItem>
        <GridItem rowStart={5} rowEnd={6} colStart={{ base: 1, lg: 2 }}>
          <Box
            position="absolute"
            bgColor="white"
            p="12px"
            borderRadius="16px"
            boxShadow="0px 25px 50px -12px rgba(0, 0, 0, 0.25);"
            zIndex={3}
          >
            <Image width={48} height={48} src="/images/how-it-works/icon4.svg" alt="icon" />
          </Box>
        </GridItem>
        <GridItem colStart={{ base: 1, lg: 2 }} rowStart={1} rowEnd={6}>
          <Flex w="100%" h="100%" justifyContent="center">
            <Box
              border="2px solid #319795"
              w="1px"
              h="100%"
              position="relative"
              _before={{
                content: '""',
                position: 'absolute',
                top: '-8px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '16px',
                height: '16px',
                borderRadius: '50%',
                backgroundColor: '#319795',
              }}
            />
          </Flex>
        </GridItem>
        <GridItem colStart={{ base: 2, lg: 3 }} rowStart={2}>
          <Flex direction="column" h="100%" mt="12px">
            <Text fontSize="24px" fontWeight="700" lineHeight="32px" color="blue.600">
              {t('seoConsulting.howItWorks.items.title1')}
            </Text>
            <Text fontSize="16px" lineHeight="24px" color="gray.600">
              {t('seoConsulting.howItWorks.items.description1')}
            </Text>
          </Flex>
        </GridItem>
        <GridItem colStart={{ base: 2, lg: 1 }} rowStart={3}>
          <Flex direction="column" h="100%" alignItems={{ base: 'flex-start', lg: 'flex-end' }} mt="12px">
            <Text fontSize="24px" fontWeight="700" lineHeight="32px" color="blue.600">
              {t('seoConsulting.howItWorks.items.title2')}
            </Text>
            <Text fontSize="16px" lineHeight="24px" color="gray.600" textAlign={{ base: 'left', lg: 'right' }}>
              {t('seoConsulting.howItWorks.items.description2')}
            </Text>
          </Flex>
        </GridItem>
        <GridItem colStart={{ base: 2, lg: 3 }} rowStart={4}>
          <Flex direction="column" h="100%" mt="12px">
            <Text fontSize="24px" fontWeight="700" lineHeight="32px" color="blue.600">
              {t('seoConsulting.howItWorks.items.title3')}
            </Text>
            <Text fontSize="16px" lineHeight="24px" color="gray.600">
              {t('seoConsulting.howItWorks.items.description3')}
            </Text>
          </Flex>
        </GridItem>
        <GridItem colStart={{ base: 2, lg: 1 }} rowStart={5} rowEnd={6}>
          <Flex direction="column" h="100%" alignItems={{ base: 'flex-start', lg: 'flex-end' }} mt="12px">
            <Text fontSize="24px" fontWeight="700" lineHeight="32px" color="blue.600">
              {t('seoConsulting.howItWorks.items.title4')}
            </Text>
            <Text fontSize="16px" lineHeight="24px" color="gray.600" textAlign={{ base: 'left', lg: 'right' }}>
              {t('seoConsulting.howItWorks.items.description4')}
            </Text>
          </Flex>
        </GridItem>
      </Grid>
    </Flex>
  );
}
